import { ConnecticShapeId } from '@core/constants/Shape';
import { IFormFieldShapeQuantities } from '../../../interfaces/Form';

const fieldsConnectics: IFormFieldShapeQuantities = {
    [ConnecticShapeId.CableGland]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [ConnecticShapeId.ELEConnector]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [ConnecticShapeId.HDMIConnector]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [ConnecticShapeId.ETHERNETConnector]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
    [ConnecticShapeId.USBConnector]: {
        value : undefined,
        min   : 0,
        max   : 10,
    },
};

export default fieldsConnectics;
